// extracted by mini-css-extract-plugin
export default {"sidebar-with-text-bubble-modal-wrapper":"sidebar-with-text-bubble-modal-wrapper-162d"};